import type { TrackingMethodChoiceManager } from './use-tracking-method-choice';
import { ConfirmDialog } from '@/components/Dialogs';
import { SERVER_TRACKING_CONFIRM } from './tracking-methods';

type ServerTrackingConfirmProps = { choice: TrackingMethodChoiceManager };

/** Asks before Server-side is chosen for a website with no active server key. */
export const ServerTrackingConfirm = ({ choice }: ServerTrackingConfirmProps) => (
  <ConfirmDialog
    open={choice.confirmingServer}
    title={SERVER_TRACKING_CONFIRM.title}
    confirmLabel={SERVER_TRACKING_CONFIRM.confirm}
    onConfirm={choice.confirmServer}
    onCancel={choice.cancelServer}
  >
    {SERVER_TRACKING_CONFIRM.body.map((text, idx) => (
      <p key={idx} className={idx === 0 ? 'supporting m-0' : 'supporting m-0 mt-2'}>
        {text}
      </p>
    ))}
  </ConfirmDialog>
);
